import React,{Component} from "react";

// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Badge,
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  NavLink,
  Container,
  UncontrolledTooltip
} from "reactstrap";
// core components



class UserNotifications extends Component{
    ctr = 1;

    /*
        user:[
                {
                    type:"credit-card",
                    message:"Update your credit card",
                },
                {
                    type:"home-address",
                    message:"Enter your home address"
                }
            ],
    */
    generateUserNotifications = (notificationList,accountType)=>{
        const {history} = this.props;
        
        return notificationList.map(n=>{
            const {type,message} = n;
            let navigationLink = ""
            switch(type){
                case "credit-card":
                    navigationLink = "/myaccount/view-profile/payment-info";
                    break;
                case "home-address":
                    navigationLink =  "/myaccount/view-profile/home-address";
                    break;
                
            }
            return <a   
                        key={this.ctr++}
                        className="notification-item cursor"
                        onClick={(e) =>{
                            e.preventDefault();
                            history.push(navigationLink)
                        }}
                    >
                        <div className="notification-text">
                            <Badge color="info" pill>
                                <i className="nc-icon nc-alert-circle-i" />
                            </Badge>
                            <span className="message">
                                {message}
                            </span>
                        </div>
                    </a>
        })
    }
    
    render(){
        const {match,userNotifications} = this.props;
        const {notificationCount} = userNotifications;
        
        const accountType = match.params.accountType || ""
  
        
        return(
            <UncontrolledDropdown>
                <DropdownToggle
                    data-toggle="dropdown"
                    tag={NavLink}
                >
                    <span className="ml-2 position-relative">
                        <Button
                            className="btn-just-icon"
                            color="default"
                            onClick={(e) => e.preventDefault()}
                        >
                            <i className="nc-icon nc-email-85" />
                        </Button>
                        <Badge
                            className="lb-notification-bubble"
                            color="danger"
                            pill
                            
                        >
                            {notificationCount}
                        </Badge>
                    </span>
                </DropdownToggle>

                <DropdownMenu
                className="dropdown-wide dropdown-notification"
                tag="ul"
                right
                >
                <DropdownItem header>
                    You have {notificationCount} pending action item
                </DropdownItem>
                <li>
                    <ul className="dropdown-notification-list scroll-area">
                    {
                        userNotifications.user.length && 
                        this.generateUserNotifications(userNotifications.user,accountType)
                    }
                    </ul>
                </li>
                {/* end scroll area */}
                </DropdownMenu>
            </UncontrolledDropdown>

        )


    }
}

export default UserNotifications;
